import React, { Fragment, useState, useEffect } from "react";
import { FormControl } from "baseui/form-control";
import { Input, SIZE as ISIZE } from "baseui/input";
import { Textarea, SIZE as TSIZE } from "baseui/textarea";
import ImageUploaderComponent from "../../components/image-uploader/ImageUploaderComponent";
import { Radio, RadioGroup } from "baseui/radio";
import { connect } from "react-redux";
import { updateActiveTemplateProperties, updateTemplateModelerThumbnailImage } from "../../redux/template/TemplateActions";
import { uploadTemplateModelerThumbnailImage } from "../../redux/template/TemplateThunk";
import { ACCESS_TYPES, RESOURCE_TYPES } from "../../constants/AppEnums";
import { getSignedUrl } from "../../helpers/S3Helpers";
import { GET_SIGNED_URL_PATH } from "../../constants/ApiConstants";
import { useTranslation } from "react-i18next";
function TemplateModelerPropertiesAsideView(props) {
  const { t } = useTranslation("template");
  const [thumbnailImageUrl, setThumbnailImageUrl] = useState(
    props.thumbnailImageUrl
  );  

  const [modelerData, setModelerData] = useState({
    modelerDescription: props.activeTemplate?.modelerDescription || "",
    modelerTitle: props.activeTemplate?.modelerTitle || "",
    modelerAccess: props.activeTemplate?.modelerAccess || ACCESS_TYPES.PUBLIC,
  });

  useEffect(() => {
    setThumbnailImageUrl(props.thumbnailImageUrl);
  }, [props.thumbnailImageUrl]);

  useEffect(() => {
    setModelerData((prevData) => ({
      ...prevData,
      modelerDescription: props.activeTemplate?.modelerDescription || "",
      modelerTitle: props.activeTemplate?.modelerTitle || "",
      modelerAccess: props.activeTemplate?.modelerAccess || ACCESS_TYPES.PUBLIC,
    }));
    if (props.activeTemplate?.modelerThumbnailImageUrl) return;
    if (!props.activeTemplate?.id || !props.activeTemplate?.modelerThumbnailImage) return;
    getSignedUrl(
      GET_SIGNED_URL_PATH,
      "template",
      `${props.activeTemplate.id}/${props.activeTemplate.modelerThumbnailImage}`
    ).then((url) => {
      props.setModelerThumbnailImageUrl(url);
      setThumbnailImageUrl(url);
    });
  }, [props.activeTemplate, props.activeTemplate.modelerThumbnailImage]);

  const handleUpdate = (updatedProperty, updatedValue) => {
    if (modelerData[updatedProperty] !== updatedValue) {
      const updatedData = { ...modelerData, [updatedProperty]: updatedValue };
      setModelerData(updatedData);
      props.updateActiveTemplateProperties(updatedData);
    }
  };

  const handleBlur = (propertyName) => {
    if (modelerData[propertyName] !== props.activeTemplate[propertyName]) {
      props.updateActiveTemplateProperties({
        [propertyName]: modelerData[propertyName],
      });
    }
  };


  return (
    <Fragment>
      <FormControl
        id="template-modeler-image"
        label={() => t("modelerThumbnailImage")} // Step 3: Replace hardcoded text
      >
        <ImageUploaderComponent
          height={"250px"}
          backgroundImage={thumbnailImageUrl}
          handleUploadFiles={props.uploadThumbnailImage}
        />
      </FormControl>
      <FormControl id="template-modeler-title" label={() => t("modelerTitle")}>
        <Input
          size={ISIZE.mini}
          value={modelerData.modelerTitle}
          onChange={(e) => handleUpdate("modelerTitle", e.target.value)}
          onBlur={() => handleBlur("modelerTitle")}
        />
      </FormControl>
      <FormControl
        id="template-modeler-description"
        label={() => t("modelerDescription")}
      >
        <Textarea
          size={TSIZE.mini}
          value={modelerData.modelerDescription}
          placeholder={t("promptModelerDescription")}
          onChange={(e) => handleUpdate("modelerDescription", e.target.value)}
          onBlur={() => handleBlur("modelerDescription")}
        />
      </FormControl>
      <RadioGroup
        name="modelerAccess"
        value={modelerData.modelerAccess}
        onChange={(e) => handleUpdate("modelerAccess", e.target.value)}
      >
        <Radio
          value={ACCESS_TYPES.PUBLIC}
          description={t("modelerPublicDescription")}
        >
          {t("modelerAccessPublic")}
        </Radio>
        <Radio
          value={ACCESS_TYPES.PRIVATE}
          description={t("modelerPrivateDescription")}
        >
          {t("modelerAccessPrivate")}
        </Radio>
      </RadioGroup>
    </Fragment>
  );
}
const mapStateToProps = (state) => {
  return {
    activeTemplate: state.template.activeTemplate,
    thumbnailImageUrl: state.template.activeTemplate?.modelerThumbnailImageUrl,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateActiveTemplateProperties: (template) => {
      dispatch(updateActiveTemplateProperties({ template }));
    },
    uploadThumbnailImage: (imageFile) => {
      dispatch(uploadTemplateModelerThumbnailImage(imageFile));
    },
    setModelerThumbnailImageUrl: (url) => {
      dispatch(updateTemplateModelerThumbnailImage({ imageUrl: url }));
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateModelerPropertiesAsideView);
